import { render } from "./ClothingColor.modal.vue?vue&type=template&id=7702bb25"
import script from "./ClothingColor.modal.vue?vue&type=script&lang=js"
export * from "./ClothingColor.modal.vue?vue&type=script&lang=js"

import "./ClothingColor.modal.vue?vue&type=style&index=0&id=7702bb25&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection});
